<!------------ START TEMPLATE ------------>
<template>
  <div>
    <div v-if="dados">
      <h4 class="mb-4 text-center">
        {{ dados.nomeProduto }}: {{ dados.valor | currency }}
      </h4>

      <div class="vx-row mb-4">
        <span class="textoModal vx-col w-full mb-3"
          >Selecione o Tipo de Desconto:</span
        >
        <div
          v-for="item in tiposDeDescontos"
          :key="`${item.id}-${Math.floor(Math.random() * 20)}`"
          class="vx-col w-full mb-3"
        >
          <vs-checkbox
            switch
            @change="alterarSomente1(item)"
            class="mt-2"
            v-model="item.selecionado"
          >
            {{ item.label }}
          </vs-checkbox>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <span class="textoModal mb-3">Selecione a Forma de aplicação:</span>
          <v-select
            @change="limpaDesconto"
            :options="tipoDesconto"
            v-model="form.tipoDesconto"
            name="Tipo Desconto"
            id="Tipo Desconto"
            v-validate="{ required: true }"
            :key="`Tipo Desconto`"
          ></v-select>
        </div>
      </div>

      <div v-if="form.tipoDesconto == 'Desconto por Valor'" class="mt-4 mb-3">
        <p class="textoModal">
          Desconto por Valor: Máximo de {{ descontoValor | currency }}
        </p>
        <vs-input
          v-money="money"
          v-model="form.valorDesconto"
          class="mt-4 mb-2 w-full"
          id="desconto Por Valor"
          name="desconto Por Valor"
          v-validate="{ min_value: 0, max_value: `${descontoValor}` }"
          :state="validateState('desconto Por Valor')"
          :danger="validateClass('desconto Por Valor')"
          :key="`desconto Por Valor`"
        />
      </div>

      <div
        v-if="form.tipoDesconto == 'Desconto por Porcentagem'"
        class="mt-4 mb-3"
      >
        <p class="textoModal">
          Desconto por Porcentagem: Até {{ porcentagem }}%
        </p>
        <vs-input
          v-money="money"
          v-model="form.valorDesconto"
          v-validate="{ min_value: 0, max_value: `${porcentagem}` }"
          id="desconto Por Porcentagem"
          name="desconto Por Porcentagem"
          :state="validateState('desconto Por Porcentagem')"
          :danger="validateClass('desconto Por Procentagem')"
          class="mt-4 mb-2 w-full"
          :key="`desconto Por Procentagem`"
        />
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <vs-button
        v-if="tiposDeDescontos.length > 0"
        color="success"
        class="w-full mt-2"
        @click="onSubmit(dados)"
        >Dar desconto</vs-button
      >

      <vs-alert
        v-if="valorIncorreto == true"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li class="mb-2">O Desconto oferecido é maior que o permitido</li>
        </ul>
      </vs-alert>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import { VMoney } from 'v-money';
import service from '../../services';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contador: {
      type: Number,
    },
  },
  watch: {
    contador: function () {
      this.preparaDescontos();
      this.preencheForm();
    },
    dados() {
      if (this.dados) {
        this.buscaTipoDescontoProduto();
        this.alterarSomente1();
        this.preparaDescontos();
        this.preencheForm();
      }
    },
  },

  data() {
    return {
      tipoDesconto: ['Desconto por Valor', 'Desconto por Porcentagem'],
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      modalForm: false,
      produtoToDesconto: null,
      form: {
        tipoDesconto: '',
        id_produto: null,
        valorDesconto: 0,
        tiposDescontos: [],
        idTipoDesconto: 0,
      },
      descontoValor: 0,
      selecionado: false,
      valorIncorreto: false,
      currency: 'R$',
      option: true,
      tiposDeDescontos: [],
      valorTipoDesconto: 0,
      porcentagem: 0,
    };
  },

  directives: { money: VMoney },
  methods: {
    limpaDesconto() {
      this.form.valorDesconto = 0;
    },
    alterarSomente1(item) {
      this.porcentagem = item.porcentagem;
      this.idDesconto = item.id;

      this.descontoValor = parseFloat(
        (this.dados.valor * this.porcentagem) / 100,
      );

      this.form.valorDesconto = 0;

      this.tiposDeDescontos.forEach((element) => {
        if (element.id == item.id) {
          item.selecionado = true;
          this.form.valorDesconto = 0;
        } else {
          element.selecionado = false;
          this.form.valorDesconto = 0;
        }
      });
    },
    preencheForm() {
      this.form.valorDesconto = 0;
      if (this.dados)
        if (this.dados.descontoConcedido > 0) {
          this.form.valorDesconto = this.dados.descontoConcedido;
        }
      this.$forceUpdate();
    },
    preparaDescontos() {},
    formataMoeda(valor) {
      if (valor != null) return `R$ ${valor.toFixed(2)} `;
    },
    onSubmit(dados) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.form.tipoDesconto == 'Desconto por Valor') {
            const valorDescontoMaiorDescontoValor =
              Number(this.form.valorDesconto) > Number(this.descontoValor);

            if (valorDescontoMaiorDescontoValor) {
              this.valorIncorreto = true;
            } else {
              dados.valorDesconto = Number(this.form.valorDesconto);
              const descontoFinal =
                Number(this.dados.valor) - Number(this.form.valorDesconto);
              dados.valorFinal = descontoFinal;
              dados.idTipoDesconto = this.idDesconto;
              dados.tipoDesconto = this.form.tipoDesconto;
              dados.descontoConcedido = Number(
                (this.form.valorDesconto * 100) / this.dados.valor,
              );
              this.valorIncorreto = false;

              this.$emit('salvarDesconto', dados);
            }
          }

          if (this.form.tipoDesconto == 'Desconto por Porcentagem') {
            const valorDescontoMaiorDescontoMaximo =
              Number(this.form.valorDesconto) > Number(this.porcentagem);

            if (valorDescontoMaiorDescontoMaximo) {
              this.valorIncorreto = true;
            } else {
              dados.valorDesconto = Number(this.form.valorDesconto);
              const valorFinal =
                Number(this.dados.valor) -
                (Number(this.dados.valor) * Number(this.form.valorDesconto)) /
                  100;
              dados.valorFinal = valorFinal;
              dados.idTipoDesconto = this.idDesconto;
              dados.tipoDesconto = this.form.tipoDesconto;
              dados.descontoConcedido = Number(this.form.valorDesconto);
              this.valorIncorreto = false;
              this.$emit('salvarDesconto', dados);
              this.form.valorDesconto = 0;
            }
          }
        }
      });
    },
    buscaTipoDescontoProduto() {
      if (this.dados) {
        var objSend = {
          estado: this.dados.estado,
          tipoProposta: this.dados.tipoProposta,
          idProduto: this.dados.id,
        };
        service
          .post('Cotacao', 'buscaTiposDescontosProduto', objSend)
          .then((res) => {
            res.data.forEach((element) => {
              if (element.idTipoDesconto == 0) {
                element.selecionado = true;
              } else {
                element.selecionado = false;
              }

              this.tiposDeDescontos.push({
                id: element.idTipoDesconto,
                label: element.tipoDesconto,
                porcentagem: element.porcentagemDescontoMaxima,
                selecionado: element.selecionado,
              });

              this.idDesconto = element.idTipoDesconto;
              this.porcentagem = this.tiposDeDescontos[0].porcentagem;

              this.idDesconto = 0;
              this.form.valorDesconto = 0;
              this.descontoValor = parseFloat(
                (this.dados.valor * this.porcentagem) / 100,
              );
            });
          })
          .catch((e) => {
            console.error(e);
            this.erroConexao =
              'Seu aplicativo parece estar offline, verifique sua conexao';
          });
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
  },
  mounted() {
    if (this.dados) {
      this.buscaTipoDescontoProduto();
      this.preparaDescontos();
      this.preencheForm();
    }
  },
  created() {
    this.form.tipoDesconto = 'Desconto por Valor';
  },
  components: {
    'v-select': vSelect,
  },
};
</script>

<style>
.textoModal {
  font-size: 1.1rem;
}
</style>
